import { stringify } from 'qs';

import { HELP_LINK_INFO } from '@/components/Help/constants/helpLinkInfo';

type Props = {
  for: keyof typeof HELP_LINK_INFO;
};

/** 도움말 보러가기 링크 */
const Help = ({ for: _for }: Props) => {
  const { articleId, category, device } = HELP_LINK_INFO[_for];
  const href = `https://cs.kakao.com/helps?${stringify({
    service: 233,
    category,
    device,
    articleId,
    locale: 'ko'
  })}`;

  return (
    <a href={href} className="link_tit" target="_blank" rel="noreferrer">
      <span className="txt_g">도움말 보러가기</span>
      <span className="ico_wallet ico_arr18" />
    </a>
  );
};

export default Help;
